// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2fhCF","content":"GlobalSearch_content__1bTN3"};